import React from 'react';
import { Box, Container, Grid, Typography, Stack, Paper, Rating } from '@mui/material';
import GetEBookButton from '../components/GetEBookButton';
import { Divider } from '@mui/material';

export default function CraftYourJourneyPage() {
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', py: { xs: 6, md: 10 } }}>
      <Box sx={{ maxWidth: 'lg', mx: 'auto', px: { xs: 2, md: 0 } }}>
        <Grid container spacing={8} alignItems="center">
          <Grid item xs={12} md={6}>
            <Stack spacing={3}>
              <Typography variant="h1" sx={{ fontSize: { xs: '2.4rem', md: '3rem' } }}>
                Happy US: A Parental Guide to Raising Joyful, Resilient & Hopeful Kids
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 500, color: 'text.secondary' }}>
                A heart-led, science-backed guide trusted by over 1,000 parents worldwide for raising emotionally strong kids and enjoying the process, too.
              </Typography>
              <Stack spacing={1}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                  Parenting DOESN'T come with a Manual...
                </Typography>
                <Typography variant="body1">
                  But it can come with <Box component="span" sx={{ textDecoration: 'underline', textDecorationThickness: '2px', textDecorationColor: 'primary.main' }}>calm, clarity, and connection</Box>.
                </Typography>
                <Typography variant="body1">
                  Every parent wants to raise emotionally strong, kind, and confident kids...
                </Typography>
              </Stack>
              <Stack spacing={2}>
                <Typography variant="body1">
                  However, most of them don't realize that those traits can actually be taught through small, <Box component="span" sx={{ fontWeight: 600 }}>science-backed practices</Box> that easily integrate into everyday life. That's exactly what <Box component="span" sx={{ fontWeight: 600 }}>&quot;Happy US&quot;</Box> helps you do.
                </Typography>
                <Typography variant="body1">
                  Rooted in the science of <Box component="span" sx={{ fontWeight: 600 }}>Positive Psychology</Box>, <Box component="span" sx={{ fontStyle: 'italic' }}>Happy US</Box> gives you simple printable activities, gentle rituals, and one-page practices you can do between breakfast and school that teach emotional intelligence and gratitude to your kids without stress.
                </Typography>
              </Stack>
              <GetEBookButton />
              <Stack direction="row" spacing={2} alignItems="center" pt={1}>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>Applauded by readers worldwide:</Typography>
                <Rating value={5} readOnly precision={0.5} />
                <Typography variant="body2" sx={{ fontWeight: 600 }}>(4.98)</Typography>
              </Stack>
            </Stack>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={6} sx={{ p: 4, borderRadius: 4 }}>
              <Stack spacing={2} textAlign="center">
                <Typography variant="h4">"Happy US"</Typography>
                <Typography variant="h6" sx={{ fontWeight: 600 }}>
                  A Parental Guide for the Positive Psychology Kids' Program (PPKP)
                </Typography>
                <Typography variant="subtitle2" sx={{ textTransform: 'uppercase', letterSpacing: 1, color: 'text.secondary' }}>
                  Fundamentals for Every Happy Child & Family
                </Typography>
                <DividerSection />
                <Stack spacing={0.5} pt={1}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>by Sara Hafez</Typography>
                  <Typography variant="caption" color="text.secondary">MSc in Applied Positive Psychology &</Typography>
                  <Typography variant="caption" color="text.secondary">MA in Early Childhood Education</Typography>
                </Stack>
              </Stack>
            </Paper>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

function DividerSection() {
  return <Divider sx={{ mt: 2 }} />;
}